module.exports = __webpack_public_path__ + "img/img-3.6e03736d.svg";